import {Record} from 'immutable';
import moment from 'moment-timezone';
import {type Moment} from 'moment-timezone';

import generateUUID from 'web-app/util/uuid';

export interface MonthlyPrice {
    price: number;
    pricingGroupId: string;
}

export enum BookingType {
    ProductBooking = 'ProductBooking',
    SessionBooking = 'SessionBooking',
}

interface ISessionBooking {
    readonly bookingType: BookingType;
    readonly day: string;
    readonly sessionId: string;
    readonly sessionVersion: string;
    readonly loading: boolean;
    readonly fundedMinutes: number | null;
    readonly monthlyPrices: MonthlyPrice[];
    readonly fundable: boolean | null;
    readonly bookingId: string;
    readonly start: Moment | null;
    readonly end: Moment | null;
}

export class SessionBooking extends Record<ISessionBooking>({
    bookingType: BookingType.SessionBooking,
    day: '',
    sessionId: '',
    sessionVersion: '',
    loading: false,
    fundedMinutes: null,
    monthlyPrices: [],
    fundable: null,
    bookingId: '',
    start: null,
    end: null,
}) {}

const fromAPI = (data: any) => {
    return new SessionBooking({
        ...data,
        start: data.start ? moment(data.start, 'HH:mm') : null,
        end: data.end ? moment(data.end, 'HH:mm') : null,
        bookingId: data.bookingId || generateUUID(),
    });
};

export default {
    record: SessionBooking,
    default: new SessionBooking(),
    fromAPI,
};
